import { useState } from "react";

export default function TableHeader() {
  // State to track sort direction for sortable columns
  const [sortConfig, setSortConfig] = useState({
    column: "Start Date",
    direction: "asc",
  });

  // Handle sorting when a sortable column is clicked
  const handleSort = (column) => {
    setSortConfig((prevConfig) => ({
      column: column,
      direction:
        prevConfig.column === column && prevConfig.direction === "asc"
          ? "desc"
          : "asc",
    }));
  };

  // Cell base style - aligned with the task row cells
  const cellStyle = {
    padding: "10px 16px",
    display: "table-cell",
    verticalAlign: "middle",
    overflow: "hidden",
    textOverflow: "ellipsis",
    whiteSpace: "nowrap",
    fontSize: "0.875rem",
    fontWeight: "500",
    color: "#374151",
  };

  // Sortable cell style
  const sortableCellStyle = (column) => ({
    ...cellStyle,
    cursor: "pointer",
    position: "relative",
  });

  // Render sort indicator
  const renderSortIndicator = (column) => {
    if (sortConfig.column !== column) return null;

    const arrowStyle = {
      marginLeft: "4px",
      display: "inline-block",
      fontSize: "0.75rem",
    };

    return sortConfig.direction === "asc" ? (
      <span style={arrowStyle}>▲</span>
    ) : (
      <span style={arrowStyle}>▼</span>
    );
  };

  // Row container styles - matched to table layout
  const rowContainerStyle = {
    width: "100%",
    display: "table-row",
    borderBottom: "1px solid #e5e7eb",
    backgroundColor: "#fae094",
  };

  // Circle icon style
  const circleStyle = {
    display: "inline-block",
    width: "6px",
    height: "6px",
    borderRadius: "50%",
    backgroundColor: "#000",
    marginLeft: "4px",
    verticalAlign: "middle",
  };

  const headerStyle = {
    position: "fixed",
    top: '76px',
    left: '0',
    right: '0',
    zIndex: 10,
    width: "100%",
    backgroundColor: "#fae094",
    paddingLeft: "0.5rem",
    paddingRight: "0.5rem",
  };

  return (
    <div style={headerStyle}>
      <div style={rowContainerStyle}>
        {/* Checkbox + No. column (4% width) */}
        <div style={{ ...cellStyle, width: "4%" }}>No.</div>

        {/* Category (8% width) */}
        <div style={{ ...cellStyle, width: "8%" }}>Category</div>

        {/* Task Name (16% width) */}
        <div style={{ ...cellStyle, width: "16%" }}>Task name</div>

        {/* Start Date (9% width) with sort */}
        <div
          style={{ ...sortableCellStyle("Start Date"), width: "9%" }}
          onClick={() => handleSort("Start Date")}
        >
          Start Date
          {renderSortIndicator("Start Date")}
        </div>

        {/* End Date (9% width) with sort */}
        <div
          style={{ ...sortableCellStyle("End Date"), width: "9%" }}
          onClick={() => handleSort("End Date")}
        >
          End Date
          {renderSortIndicator("End Date")}
        </div>

        {/* Duration (7% width) */}
        <div style={{ ...cellStyle, width: "7%" }}>Duration</div>

        {/* Progress (9% width) */}
        <div style={{ ...cellStyle, width: "9%" }}>Progress</div>

        {/* Predecessor (9% width) */}
        <div style={{ ...cellStyle, width: "9%" }}>Predecessor</div>

        {/* Successor (8% width) */}
        <div style={{ ...cellStyle, width: "8%" }}>Successor</div>

        {/* Department (8% width) with sort */}
        <div
          style={{ ...sortableCellStyle("Department"), width: "8%" }}
          onClick={() => handleSort("Department")}
        >
          Department
          {renderSortIndicator("Department")}
        </div>

        {/* Assigned to (8% width) with sort */}
        <div
          style={{ ...sortableCellStyle("Assigned to"), width: "8%" }}
          onClick={() => handleSort("Assigned to")}
        >
          Assigned to
          {renderSortIndicator("Assigned to")}
        </div>

        {/* Estimated Delay (10% width) */}
        <div style={{ ...cellStyle, width: "10%" }}>
          Estimated Delay
          <span style={circleStyle}></span>
        </div>

        {/* Actions (3% width) - empty header for the 3-dots menu column */}
        <div style={{ ...cellStyle, width: "3%" }}></div>
      </div>
    </div>
  );
}
